var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArRomanh = function SvgArRomanh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 747.08,
    height: 410.391,
    "data-name": "Layer 1",
    viewBox: "0 0 632.99 632.99"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-romanh_svg__b",
    x1: 261.91,
    x2: 364.09,
    y1: 162.98,
    y2: 323.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c82523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#bd2221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#a11a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e1618"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-romanh_svg__c",
    x1: 265.53,
    x2: 284.23,
    y1: 349.53,
    y2: 143.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac1f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ce2928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d42e2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e53d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef453a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar-romanh_svg__a",
    x1: 353.57,
    x2: 370.27,
    y1: 240.77,
    y2: 267.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5a36a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f4a068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f19765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed8960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ar-romanh_svg__a",
    id: "ar-romanh_svg__d",
    x1: 310.37,
    x2: 327.07,
    y1: 240.77,
    y2: 267.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ar-romanh_svg__a",
    id: "ar-romanh_svg__e",
    x1: 267.53,
    x2: 284.23,
    y1: 240.77,
    y2: 267.04
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 424.67v.92c.23 2.99.48 5.8.75 8.4.27 2.61.48 4.95.63 7.02.46 4.22.88 7.87 1.27 10.94-2.84.39-5.55.71-8.12.98-2.57.27-30.19.41-31.65.41v.11h-41.9v-.11c-2.38 0-4.22-.33-5.53-.98-1.31-.65-2.25-1.73-2.82-3.22-.58-1.5-.86-3.59-.86-6.27v-38.22l-16 3.91v6.91l-21.07 8.17c-5.22 2.84-9.14 6.22-11.74 10.13-2.61 3.91-3.91 8.44-3.91 13.58 0 2.46.55 5.24 1.67 8.35 1.11 3.11 2.47 6.04 4.09 8.81 3.76 1.23 7.79 1.99 12.09 2.3s8.21.19 11.74-.34l8.29-11.74c.77 5.68 2.74 9.77 5.93 12.26 3.18 2.5 8.19 3.74 15.02 3.74h73.27v-.05c4.58-.11 8.71-.48 12.32-1.16 4.3-.81 7.75-2.09 10.36-3.86 1.69-5.91 2.65-12.59 2.88-20.03.15-7.29-.42-15.31-1.73-24.06l-14.97 3.11Zm-104.23 14.4c-.08 1.23-.4 2.46-.98 3.68-.58 1.23-1.25 2.3-2.02 3.22-.77.92-1.46 1.58-2.07 1.96-1.46.62-3.24 1.06-5.35 1.33s-4.43.44-6.96.52c-3.07.46-4.76.69-5.06.69-.85-1.23-1.54-2.47-2.07-3.74-.54-1.27-.81-2.36-.81-3.28 0-1.61.58-3.07 1.73-4.38 1.15-1.3 3.11-2.65 5.87-4.03l17.73-6.56v10.59ZM263.62 403.49l-9.32-8.98-8.87 8.98 8.87 9.21 9.32-9.21zM143.27 403.49l-9.33-8.98-8.86 8.98 8.86 9.21 9.33-9.21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m125.27 403.49-9.33-8.98-8.86 8.98 8.86 9.21 9.33-9.21zM467.74 420.18c-4.84-.23-9.14.88-12.9 3.34s-6.79 6.26-9.1 11.4c-.38.92-.75 1.8-1.09 2.65-.34.85-.71 1.73-1.09 2.65-.85 2.3-1.67 4.26-2.47 5.87-.81 1.61-1.81 3.07-2.99 4.37-1.19 1.31-2.67 2.27-4.43 2.88h-4.14v.11H302.78v-.11c-2.53 0-6.68-.15-12.43-.46 0-3.38-.02-6.64-.06-9.79-.04-3.15-.06-5.87-.06-8.17l-.11-45.48-16 2.53v50.43c0 3.99.29 8.39.86 13.18.58 4.8 1.25 9.19 2.02 13.18 2.3.54 5.18 1 8.63 1.38 3.45.39 7.25.58 11.4.58h142.41l6.22-11.51c1.38 2.38 3.18 4.55 5.41 6.51s4.74 3.49 7.54 4.61 5.7 1.67 8.69 1.67c4.99 0 9.27-1 12.84-2.99 3.57-1.99 6.29-4.78 8.17-8.35 1.88-3.57 2.82-7.58 2.82-12.03v-21.07l-7.14-7.14-16.23-.23Zm8.98 32.24c-2 1.31-4.53 1.96-7.6 1.96-2.84 0-5.74-.5-8.69-1.5-2.95-1-5.7-2.46-8.23-4.38 1.69-3.22 3.32-5.66 4.89-7.31s3.28-2.8 5.12-3.46c1.84-.65 3.99-.98 6.45-.98s5.64.31 9.56.92c.99 3.99 1.88 7.02 2.65 9.1-.77 2.46-2.15 4.34-4.15 5.64ZM525.53 395.78c0-3.53-.94-6.39-2.82-8.58-1.88-2.19-4.16-3.28-6.85-3.28-1.77 0-3.51.94-5.24 2.82-1.73 1.88-3.24 4.2-4.55 6.96.69 2.07 1.74 3.9 3.17 5.47 1.42 1.58 3.13 2.51 5.12 2.82.15.54-.46.94-1.84 1.21-1.38.27-3.11.44-5.18.52-.77.08-1.59.11-2.47.11h-2.59l-2.76 8.17c8.36 0 14.79-1.38 19.28-4.14 4.49-2.76 6.74-6.79 6.74-12.09Zm-13.7-.81c.38-.77.88-1.44 1.5-2.01.61-.58 1.23-.86 1.84-.86 1.3 0 2.4.46 3.28 1.38s1.33 2.19 1.33 3.8c0 .46-.04.92-.11 1.38-1.69-.07-3.21-.46-4.55-1.15-1.34-.69-2.44-1.53-3.28-2.53ZM525.47 441.6c-.65-5.83-1.63-11.47-2.94-16.92l-.58-.35-14.74 3.11c.08.54.17 1.08.29 1.61.12.54.25 1.07.41 1.61 1.53 6.45 2.59 11.63 3.17 15.54.58 3.91.86 8.1.86 12.55v.92c0 .31-.04.62-.12.92-.08 6.22-1.11 11.63-3.11 16.23-2 4.61-5.53 7.18-10.59 7.71-1.38.07-3.03 0-4.95-.23l-1.38 2.3 5.41 11.63h.35c.84.07 1.61.11 2.3.11s1.54-.08 2.53-.23c6.6-.85 11.68-3.32 15.25-7.43 3.57-4.11 5.93-8.69 7.08-13.76 1.15-5.06 1.73-10.47 1.73-16.23v-2.42c0-5.3-.33-10.86-.98-16.69ZM389.62 404.32v-8.4l26.02-9.44v8.4l-26.02 9.44ZM195.29 403.58v-8.4l26.02-9.44v8.4l-26.02 9.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409.42 421.06c-1.68 0-3.1-.39-4.27-1.15-1.17-.77-2.04-1.92-2.63-3.46l-3.06 6.31h-3.28c-1.97 0-3.56-.78-4.76-2.36-1.2-1.57-1.8-3.76-1.8-6.57 0-1.94.22-3.71.66-5.31l5.91-.4-.22 1.5c-.22.94-.33 1.64-.33 2.1 0 .87.18 1.54.55 2.01.36.47.87.7 1.53.7h1.2l1.42-2.71.22-4.41 5.58-.5c.07 2.07.27 3.56.6 4.46.33.9.89 1.35 1.7 1.35l2.41-.1c.07-.13.11-.32.11-.55v-.75c.07-.87.11-1.82.11-2.86s-.07-1.89-.22-2.56l5.91-.5c.22 1.94.33 3.61.33 5.01 0 2.67-.62 5.81-1.86 9.42-.36.13-1.24.39-2.63.75-1.39.37-2.44.55-3.17.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.42 187.8c-2.9-1.2-4.91-3.67-5.56-6.52h-.01s-.01-.04-.01-.06c-3.03-9.99 10.43-32.94 10.81-33.59h.01s-18.39-1.97-33.34 17.53l-15.54-30.51-15.56 30.51c-10.24-16.8-33.32-17.54-33.32-17.54s.01.04.02.05c.74 1.26 13.8 23.72 10.79 33.56 0 .02 0 .03-.01.05-.11.47-.25.93-.45 1.38-.04.12-.09.23-.15.35-.19.46-.44.89-.72 1.31-.12.18-.25.36-.39.54l-.03.03c-.11.16-.24.31-.39.47-.01.02-.03.04-.05.06-.1.12-.21.23-.33.35-.33.32-.68.63-1.06.9-.1.08-.2.15-.3.21-.13.1-.27.18-.42.26-.18.11-.36.22-.56.3-.23.13-.48.24-.72.34-31.34 12.85-52.82 39.13-52.82 69.45 0 43 43.19 77.87 96.46 77.87 1.34 0 2.65-.02 3.96-.08v22.12s44.37-24.47 68.14-46.42c15.77-14.55 21.12-30.76 22.94-40.05.95-4.36 1.43-8.86 1.43-13.44 0-30.32-21.47-56.59-52.81-69.45Zm-84.54 50.54c8.61 0 15.57 6.97 15.57 15.57s-6.96 15.56-15.57 15.56-15.56-6.96-15.56-15.56 6.96-15.57 15.56-15.57Zm42.84 31.13c-8.6 0-15.56-6.96-15.56-15.56s6.96-15.57 15.56-15.57 15.57 6.97 15.57 15.57-6.97 15.56-15.57 15.56Zm43.21 0c-8.6 0-15.57-6.96-15.57-15.56s6.97-15.57 15.57-15.57 15.56 6.97 15.56 15.57-6.96 15.56-15.56 15.56Z",
    style: {
      fill: "url(#ar-romanh_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.72 335.03c-1.32.06-2.63.08-3.96.08-53.27 0-96.46-34.87-96.46-77.87 0-30.32 21.48-56.59 52.82-69.45.24-.1.49-.21.72-.34.19-.08.38-.19.56-.3.14-.08.28-.17.42-.26.1-.06.2-.13.3-.21.39-.27.73-.58 1.06-.9.11-.11.22-.23.33-.35.02-.02.04-.04.05-.06.14-.15.27-.3.39-.47l.03-.03c.13-.17.26-.35.39-.54.28-.42.53-.85.72-1.31.06-.12.11-.23.15-.35.19-.45.33-.91.45-1.38.01-.02.01-.03.01-.05 3.01-9.84-10.05-32.31-10.79-33.56a.076.076 0 0 1-.02-.04s23.08.73 33.32 17.53l15.56-30.51v26.12c0 20.71-12.81 39.38-32.27 46.47-20.86 7.6-38.64 28.78-41.86 47.86-4.11 33.94 21.33 73.13 78.09 79.94Z",
    style: {
      fill: "url(#ar-romanh_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.49 253.91c0 8.6-6.96 15.56-15.56 15.56s-15.57-6.96-15.57-15.56 6.97-15.57 15.57-15.57 15.56 6.97 15.56 15.57Z",
    style: {
      fill: "url(#ar-romanh_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.29 253.91c0 8.6-6.97 15.56-15.57 15.56s-15.56-6.96-15.56-15.56 6.96-15.57 15.56-15.57 15.57 6.97 15.57 15.57Z",
    style: {
      fill: "url(#ar-romanh_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.45 253.91c0 8.6-6.96 15.56-15.57 15.56s-15.56-6.96-15.56-15.56 6.96-15.57 15.56-15.57 15.57 6.97 15.57 15.57Z",
    style: {
      fill: "url(#ar-romanh_svg__e)"
    }
  }));
};
export { SvgArRomanh as ReactComponent };